import React, { useState } from 'react'
import { LayoutCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/layout/LayoutCP'
import { HeaderCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/header/HeaderCP'
import { TableUtils } from 'submodules/nerit-framework-ui/common/components/table/utils/TableUtils'
import { useFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/UseFormStateManager'
import { ParameterControlFiltersFormModel } from 'modules/collection-performance/components/parameter-control/filters-parameter-control/inner/ParameterControlFiltersFormModel'
import { FiltersParameterControlCP } from 'modules/collection-performance/components/parameter-control/filters-parameter-control/FiltersParameterControlCP'
import { TableParameterControlCP } from 'modules/collection-performance/components/parameter-control/table-parameter-control/TableParameterControlCP'

/**
 * Tela 3.3 - Controle de Parametros. Grade parametro x mes (por ponto), status
 * derivado somente leitura; o usuario edita apenas a nota.
 */
export function ScreenParameterControl(): JSX.Element {

    const [formModel] = useState<ParameterControlFiltersFormModel>(new ParameterControlFiltersFormModel())
    const formStateManager = useFormStateManager(formModel)

    const [reloadData, setReloadData] = useState<number>(TableUtils.getReloadNumber())
    const [isLoading, setIsLoading] = useState<boolean>(false)

    return (
        <LayoutCP
            header={<HeaderCP title={'Desempenho de Coleta — Controle de Parâmetros'}/>}
            overflowVertical={true}
            content={
                <>
                    <FiltersParameterControlCP
                        formStateManager={formStateManager}
                        onFilter={() => setReloadData(TableUtils.getReloadNumber())}
                        isLoading={isLoading}
                    />

                    <TableParameterControlCP
                        formStateManager={formStateManager}
                        reloadData={reloadData}
                        onLoading={setIsLoading}
                    />
                </>
            }
        />
    )
}
